import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Livro } from "../types/general";

export const defaultValuesList = {
  data: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalData: 0
  }
}

interface LivroZusProps {
  livros: {
    data: Livro[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalData: number;
    };
  };
  selectedLivro: Livro | undefined;
  selectedLivrariaId: number | undefined;
  setLivros: (livros: { data: Livro[]; pagination: any }) => void;
  setSelectedLivro: (livro: Livro) => void;
  setSelectedLivrariaId: (livrariaId: number | undefined) => void;
  resetState: () => void;
  removeLivro: (id: number) => void;
  updateLivro: (livro: Livro) => void;
}

const useLivroStore = create<LivroZusProps>()(
  persist(
    (set, get) => ({
      livros: defaultValuesList,
      selectedLivro: undefined,
      selectedLivrariaId: undefined,
      setLivros: (livrosResponse) => {
        set({
          livros: {
            data: livrosResponse.data || [],
            pagination: livrosResponse.pagination || defaultValuesList.pagination
          }
        });
      },
      setSelectedLivro: (livro: Livro) => {
        set({
          selectedLivro: livro
        });
      },
      setSelectedLivrariaId: (livrariaId: number | undefined) => {
        set({
          selectedLivrariaId: livrariaId
        });
      },
      resetState: () => {
        set({
          livros: defaultValuesList,
          selectedLivro: undefined,
          selectedLivrariaId: undefined
        });
      },
      removeLivro: (id: number) => {
        const { livros } = get();
        const newState = {
          ...livros,
          data: livros.data.filter((item) => id !== item.id)
        };
        set({
          livros: newState
        });
      },
      updateLivro: (livro: Livro) => {
        const { livros } = get();
        const newState = {
          ...livros,
          data: livros.data.map((item) =>
            livro.id === item.id ? livro : item
          )
        };
        set({
          livros: newState,
          selectedLivro: livro
        });
      }
    }),
    {
      name: "livros",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useLivroStore;
